// extracted by mini-css-extract-plugin
export default {"button":"style_button__ye7c2","content":"style_content__gzeBo","hiddenText":"style_hiddenText__6S4Jf"};